import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadingSpinner } from "@/components/LoadingSpinner";
import { useAuth } from "@/auth/useAuth";

export const Login = () => {
  const { login, isAuthenticated, isInitialized, isLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const hasCalledLogin = useRef(false);

  console.log(location);

  const from = location.state?.from?.pathname || "/";

  useEffect(() => {
    const handleLogin = async () => {
      if (isInitialized && !isAuthenticated && !isLoading && !hasCalledLogin.current) {
        hasCalledLogin.current = true;
        await login();
        navigate(from, { replace: true });
      }
    };

    handleLogin();
  }, [isInitialized, isAuthenticated, isLoading, login, navigate, from]);

  if (isLoading) {
    return <LoadingSpinner message="Redirecting to login..." />;
  }

  return <LoadingSpinner message="Redirecting to login..." />;
};